import { Component, OnInit } from '@angular/core';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { FormGroup, FormControl } from '@angular/forms';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { Desk } from 'src/app/models/turns-models/desk.model';
import { Location } from 'src/app/models/turns-models/location.model';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';

@Component({
  selector: 'app-turns-controls-turns-list-card',
  templateUrl: './turns-controls-turns-list-card.component.html',
  styleUrls: ['./turns-controls-turns-list-card.component.scss']
})
export class TurnsControlsTurnsListCardComponent implements OnInit {

  centerList;
  deskList;
  locationList;
  turnList;
  formNameOrder;
  deskNameOrder;
  customerNameOrder;
  customerSurnameOrder;
  turnDateOrder;
  refreshing: boolean;
  showList: boolean;
  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(),
    selectedDesk: new FormControl(),
    selectedLocation: new FormControl()
  });
  getDesksSubscription: Subscription;
  getLocationsSubscription: Subscription;
  getTurnsByDeskSubscription: Subscription;
  nextDeskLocationByTurnSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private locationsTurnsService: LocationsTurnsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) {
                this.centerList = this.userStorageService.getCenterList();
                if (this.cacheExists()['center']) {
                  this.basicDataForm.patchValue({
                    selectedCenter: this.cacheExists()['center']
                  });
                  this.centerSelectedChanged(null);
                }
              }

  ngOnInit() {
    this.locationsTurnsService.refreshTurnslistListen().pipe().subscribe();
    this.resetSortOrders();
  }

  public centerSelectedChanged(e) {
    this.rememberCenter(this.basicDataForm.get('selectedCenter').value);
    this.basicDataForm.patchValue({
      selectedDesk: null,
      selectedLocation: null
    });
    this.getDesks();
  }

  public deskSelectedChanged(e) {
    this.rememberDesk(this.basicDataForm.get('selectedDesk').value);
    this.showList = false;
    if (this.basicDataForm.get('selectedDesk').value === 'all' && this.deskList && (this.deskList.length > 0)) {
      this.basicDataForm.patchValue({
        selectedLocation: null
      });
      const internalIds = [];
      for (const desk of this.deskList) {
        internalIds.push({ internalId: desk.InternalId });
      }
      this.getTurnsByDesk(internalIds);
    } else if (this.deskList && (this.deskList.length > 0)) {
      this.basicDataForm.patchValue({
        selectedLocation: null
      });
      this.getLocationsByDesk();
      this.getTurnsByDesk(this.basicDataForm.get('selectedDesk').value.InternalId);
    }
  }
  public locationSelectedChanged($event) {
    this.rememberLocation(this.basicDataForm.get('selectedLocation').value);
  }

  public getDesks() {
    this.basicDataForm.get('selectedDesk').disable();
    this.basicDataForm.patchValue({
      selectedLocation: null
    });
    this.getDesksSubscription = this.desksTurnsService.getDesks().subscribe(
      (res) => {
        this.deskList = this.filterDesks(res, this.basicDataForm.get('selectedCenter').value);
        this.basicDataForm.get('selectedDesk').enable();
        if (this.cacheExists()['desk']) {
          this.basicDataForm.patchValue({
            selectedDesk: this.cacheExists()['desk']
          });
          this.deskSelectedChanged(null);
        } else {
          this.basicDataForm.patchValue({
            selectedDesk: 'all'
          });
          this.deskSelectedChanged(null);
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private filterDesks(data, center) {
    return data.filter(d => (d.TurnTypeInternalId === 'MSHMV4BJ9THXZL9CIYPT25T6R7427OY42') && (d.CenterInternalId === center.internalId) );
  }

  public getLocationsByDesk() {
    this.basicDataForm.get('selectedLocation').disable();
    this.getLocationsSubscription = this.locationsTurnsService.getLocationListByDesk(this.basicDataForm.get('selectedDesk').value.InternalId).subscribe(
      (res) => {
        this.locationList = (res as Array<any>).filter(l => l.centerInternalId === this.basicDataForm.get('selectedCenter').value.internalId);
        this.basicDataForm.get('selectedLocation').enable();
        if (this.cacheExists()['location']) {
          this.basicDataForm.patchValue({
            selectedLocation: this.cacheExists()['location']
          });
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getTurnsByDesk(internalIds) {
    this.getTurnsByDeskSubscription = this.locationsTurnsService.getTurnListByDesk(internalIds).subscribe(
      (res) => {
        this.turnList = res;
        this.showList = true;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public refreshDeskTurns() {
    this.refreshing = true;
    let internalId = null;
    if (this.basicDataForm.get('selectedDesk').value === 'all') {
      internalId = [];
      for (const desk of this.deskList) {
        internalId.push({ internalId: desk.InternalId });
      }
    } else {
      internalId  = this.basicDataForm.get('selectedDesk').value.InternalId;
    }
    this.getTurnsByDeskSubscription = this.locationsTurnsService.getTurnListByDesk(internalId).subscribe(
      (res) => {
        this.turnList = res;
        this.showList = true;
        this.refreshing = false;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.refreshing = false;
      }
    );
  }

  public nextDeskLocationByTurn(turnInternalId) {
    this.nextDeskLocationByTurnSubscription = this.locationsTurnsService.nextDeskLocationByTurn(this.basicDataForm.get('selectedLocation').value.internalId, turnInternalId).subscribe(
      (res) => {
        this.refreshDeskTurns();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'formName':
        this.formNameOrder = (this.formNameOrder === 0) ? 1 : (this.formNameOrder === 1) ? -1 : 1;
        this.turnList = this.turnList.sort(
          (a, b) => {
            a.formName = a.formName ? a.formName : ' ';
            b.formName = b.formName ? b.formName : ' ';
            return (a.formName.toUpperCase() < b.formName.toUpperCase()) ? -this.formNameOrder : (a.formName.toUpperCase() > b.formName.toUpperCase()) ? this.formNameOrder : 0;
          });
        break;
      case 'deskName':
        this.deskNameOrder = (this.deskNameOrder === 0) ? 1 : (this.deskNameOrder === 1) ? -1 : 1;
        this.turnList = this.turnList.sort(
          (a, b) => {
            a.deskName = a.deskName ? a.deskName : ' ';
            b.deskName = b.deskName ? b.deskName : ' ';
            return (a.deskName.toUpperCase() < b.deskName.toUpperCase()) ? -this.deskNameOrder : (a.deskName.toUpperCase() > b.deskName.toUpperCase()) ? this.deskNameOrder : 0;
          });
        break;
      case 'customerName':
        this.customerNameOrder = (this.customerNameOrder === 0) ? 1 : (this.customerNameOrder === 1) ? -1 : 1;
        this.turnList = this.turnList.sort(
          (a, b) => {
            a.customerName = a.customerName ? a.customerName : ' ';
            b.customerName = b.customerName ? b.customerName : ' ';
            return (a.customerName.toUpperCase() < b.customerName.toUpperCase()) ? -this.customerNameOrder : (a.customerName.toUpperCase() > b.customerName.toUpperCase()) ? this.customerNameOrder : 0;
          });
        break;
      case 'customerSurname':
        this.customerSurnameOrder = (this.customerSurnameOrder === 0) ? 1 : (this.customerSurnameOrder === 1) ? -1 : 1;
        this.turnList = this.turnList.sort(
          (a, b) => {
            a.customerSurname = a.customerSurname ? a.customerSurname : ' ';
            b.customerSurname = b.customerSurname ? b.customerSurname : ' ';
            return (a.customerSurname.toUpperCase() < b.customerSurname.toUpperCase()) ? -this.customerSurnameOrder : (a.customerSurname.toUpperCase() > b.customerSurname.toUpperCase()) ? this.customerSurnameOrder : 0;
          });
        break;
      case 'turnDate':
        this.turnDateOrder = (this.turnDateOrder === 0) ? 1 : (this.turnDateOrder === 1) ? -1 : 1;
        this.turnList = this.turnList.sort(
          (a, b) => {
            a.turnDate = a.turnDate ? a.turnDate : ' ';
            b.turnDate = b.turnDate ? b.turnDate : ' ';
            return (a.turnDate < b.turnDate) ? -this.turnDateOrder : (a.turnDate) ? this.turnDateOrder : 0;
          });
        break;
    }
  }

  public resetSortOrders() {
    this.formNameOrder = 0;
    this.deskNameOrder = 0;
    this.customerNameOrder = 0;
    this.customerSurnameOrder = 0;
    this.turnDateOrder = 0;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public rememberCenter(center) {
    try {
      sessionStorage.removeItem('cache_ctlc');
      sessionStorage.setItem('cache_ctlc', JSON.stringify(Object.assign(new CenterLite(), center)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  public rememberDesk(desk) {
    try {
      sessionStorage.removeItem('cache_ctld');
      sessionStorage.setItem('cache_ctld', JSON.stringify(Object.assign(new Desk(), desk)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  public rememberLocation(location) {
    try {
      sessionStorage.removeItem('cache_ctll');
      sessionStorage.setItem('cache_ctll', JSON.stringify(Object.assign(new Location(), location)));
    } catch (e) { console.dir('Can not save info at session storage'); }
  }

  public cacheExists() {
    const c = new CenterLite();
    const d = new Desk();
    const l = new Location();
    try {
      Object.assign(c, JSON.parse(sessionStorage.getItem('cache_ctlc')));
      Object.assign(d, JSON.parse(sessionStorage.getItem('cache_ctld')));
      Object.assign(l, JSON.parse(sessionStorage.getItem('cache_ctll')));
    } catch (e) { return false; }
    const center = c.InternalId ? c : null;
    const desk = d.InternalId ? d : null;
    const location = l.InternalId ? l : null;
    return { center, desk, location };
  }

  ngDestroy() {
    if (this.getDesksSubscription) { this.getTurnsByDeskSubscription.unsubscribe(); }
    if (this.getTurnsByDeskSubscription) { this.getTurnsByDeskSubscription.unsubscribe(); }
    if (this.nextDeskLocationByTurnSubscription) { this.nextDeskLocationByTurnSubscription.unsubscribe(); }
  }
}
